import React, { useEffect, useState } from "react";
import { Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { getAssignLicenseRequests } from "@utils/api-communication/RestApiCli";

type Props = {
  to?: string;
  variant?: "filled" | "light" | "outline" | "default" | "subtle" | "transparent";
  size?: "xs" | "sm" | "md" | "lg" | "xl";
};

export default function LicenseAssignmentRequestsButton({
  to = "/assign-requests",
  variant = "outline",
  size = "sm",
}: Props) {
  const navigate = useNavigate();
  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    let mounted = true;
    getAssignLicenseRequests(
      (resp: any) => {
        if (!mounted) return;
        const list = resp?.data ?? [];
        const pending = (list || []).filter((r: any) => !r?.isApproved).length;
        setCount(pending);
      },
      () => {
        if (!mounted) return;
        setCount(0);
      },
    );
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Button variant={variant} size={size} onClick={() => navigate(to)}>
      {`License Assignment Requests (${count})`}
    </Button>
  );
}
